import { useMemo } from 'react';

/**
 * Root entry always resolves to the catalog.
 *
 * We intentionally do not branch on prior activity here: user-facing entry
 * truth now requires `/catalog` for every login/runtime path.
 */
export function useDefaultTab(): { defaultTab: string; resolved: boolean } {
  return useMemo(() => ({ defaultTab: '/catalog', resolved: true }), []);
}
